import { jsonb, text } from "drizzle-orm/pg-core";

export { resolvePart, type DisplayPart, type DisplayNameMeta } from "./display-name-meta";
import type { DisplayNameMeta } from "./display-name-meta";

/**
 * Drop-in column spread for entities that adopt the shared display-identity
 * pattern. `displayName` is the full composed, searchable string;
 * `displayNameMeta` holds only the variable parts. Both server-maintained.
 */
export const displayNameProps = {
	displayName: text("display_name"),
	displayNameMeta: jsonb("display_name_meta").$type<DisplayNameMeta>()
};
